import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '2141b0e5a5426a48205a077c9425f40f';

//2141b0e5a5426a48205a077c9425f40f

mixpanel.init(MIXPANEL_TOKEN, {
  autocapture: true,
  record_sessions_percent: 100,
  debug: process.env.NODE_ENV !== 'production',
});

// ============ 추가된 부분 시작 ============
const enrichNaverParams = () => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);

  // 네이버 광고 추적 파라미터들
  const naverKeys = [
    'n_media',         // 매체 ID
    'n_query',         // 사용자가 실제로 친 검색어
    'n_rank',          // 광고 노출 순위
    'n_ad_group',      // 광고그룹 ID
    'n_ad',            // 광고 소재 ID
    'n_keyword_id',    // 키워드 ID
    'n_keyword',       // 등록한 키워드
    'n_campaign_type', // 캠페인 타입
    'n_ad_group_type', // 광고그룹 타입
    'n_match',         // 매칭 타입 (1=정확, 2=확장 등)
    'n_contract',      // 계약 정보
  ];

  const naverParams: Record<string, string> = {};
  naverKeys.forEach((key) => {
    const value = params.get(key);
    if (value) naverParams[key] = value;
  });

  if (Object.keys(naverParams).length > 0) {
    // 마지막 터치 (이후 모든 이벤트에 자동 첨부, 새 광고 클릭 시 갱신됨)
    mixpanel.register(naverParams);

    // 첫 터치 (최초 유입 시점만 기록, 이후 덮어쓰지 않음)
    const initialNaverParams: Record<string, string> = {};
    Object.entries(naverParams).forEach(([k, v]) => {
      initialNaverParams[`initial_${k}`] = v;
    });
    mixpanel.register_once(initialNaverParams);
  }
};

enrichNaverParams();
// ============ 추가된 부분 끝 ============

export const track = (event: string, properties?: Record<string, any>) => {
  mixpanel.track(event, properties);
};

export const getDistinctId = (): string => {
  return mixpanel.get_distinct_id();
};

export const identifyUser = (phone: string, props?: Record<string, any>) => {
  mixpanel.identify(phone);
  mixpanel.people.set({ '$phone': phone, ...props });
};

export const identifyFamily = (
  studentPhone: string,
  parentPhone: string,
  props?: Record<string, any>
) => {
  if (!studentPhone) {
    console.warn('[mixpanel] identifyFamily: studentPhone is required');
    return;
  }

  mixpanel.identify(studentPhone);
  if (parentPhone && parentPhone !== studentPhone) {
    try {
      mixpanel.alias(parentPhone, studentPhone);
    } catch (e) {
      console.warn('[mixpanel] alias failed:', e);
    }
  }
  mixpanel.people.set({
    '$phone': studentPhone,
    'student_phone': studentPhone,
    'parent_phone': parentPhone,
    ...props,
  });
};

export const getAttributionProps = () => {
  return {
    initial_utm_source: mixpanel.get_property('$initial_utm_source'),
    initial_utm_medium: mixpanel.get_property('$initial_utm_medium'),
    initial_utm_campaign: mixpanel.get_property('$initial_utm_campaign'),
    initial_utm_content: mixpanel.get_property('$initial_utm_content'),
    initial_utm_term: mixpanel.get_property('$initial_utm_term'),
    last_utm_source: mixpanel.get_property('utm_source'),
    last_utm_medium: mixpanel.get_property('utm_medium'),
    last_utm_campaign: mixpanel.get_property('utm_campaign'),
     // 네이버
    initial_n_query: mixpanel.get_property('initial_n_query'),
    initial_n_keyword: mixpanel.get_property('initial_n_keyword'),
    last_n_query: mixpanel.get_property('n_query'),
    last_n_keyword: mixpanel.get_property('n_keyword'),
    last_n_ad_group: mixpanel.get_property('n_ad_group'),
    last_n_rank: mixpanel.get_property('n_rank'),
    last_n_match: mixpanel.get_property('n_match'),
  };
};

export default mixpanel;
